import { FC, PropsWithChildren } from 'react'

type LinkPreviewWrapperProps = PropsWithChildren & {
  url?: string | null
  className?: string
}

const LinkPreviewWrapper: FC<LinkPreviewWrapperProps> = ({
  url,
  children,
  className,
}) =>
  url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-testid="link-preview"
    >
      {children}
    </a>
  ) : (
    <div data-testid="link-preview" className={className}>
      {children}
    </div>
  )

export default LinkPreviewWrapper
